module.exports = __webpack_public_path__ + "img/p5.d1e945ec.png";